import { useLingui } from '@lingui/react/macro';
import classNames from 'classnames';

import { BarChart3, Bell, Bot, Calendar, CreditCard, Database, LayoutPanelTop, ListTodo, Puzzle, Rss, Users } from 'lucide-react';
import { Pages } from 'modules/navigation/domain/enums/pages';
import useUnreadNotifications from 'modules/notifications/ui/hooks/use-unread-notifications';
import UsersAppIcon from 'ud-ui/components/icon/users-icon';
import React from 'react';
import { checkIsDev } from 'shared/utils/check-is-dev';
import MenuItem from '../menu-item';

type Props = { className?: string };

/** Очередь — свой пункт меню, хотя её адрес вложен в `/manager`: «Медиа менеджер» на ней не подсвечивается. */
const MEDIA_MANAGER_EXCLUDED_PATHS = [Pages.MEDIA_MANAGER.QUEUE];

const UDMenuSystemNavigation = React.memo((props: Props) => {
  const { unreadCount } = useUnreadNotifications();
  const { t } = useLingui();

  let badge = unreadCount > 0 ? { label: unreadCount.toString() } : undefined;

  return (
    <div className={classNames('flex flex-col', props.className)}>
      <MenuItem to={Pages.NOTIFICATIONS.INDEX} icon={<Bell size={16} />} label={t`Уведомления`} badge={badge} />
      <MenuItem to={Pages.SCHEDULE.INDEX} icon={<Calendar size={16} />} label={t`Расписание`} />
      <MenuItem to={Pages.ORGANIZERS.INDEX} icon={<Users size={16} />} label={t`Организаторы`} adminOnly={true} />
      <MenuItem to={Pages.PLANS.INDEX} icon={<CreditCard size={16} />} label={t`Тарифы`} adminOnly={true} />
      <MenuItem to={Pages.ROLES_MANAGER.INDEX} icon={<UsersAppIcon width={16} height={16} />} label={t`Пользователи`} />
      <MenuItem to={Pages.TEMPLATE.INDEX} icon={<LayoutPanelTop size={16} />} label={t`Трансляции`} />
      <MenuItem to={Pages.MIGRATION.INDEX} icon={<Database size={16} />} label={t`Миграция`} adminOnly={true} />
      <MenuItem to={Pages.ANALYTICS.INDEX} icon={<BarChart3 size={16} />} feature={'TOURNAMENT_ANALYTICS'} label={t`Аналитика`} />
      <MenuItem to={Pages.CHAT.INDEX} icon={<Bot size={16} />} feature={'AI_CHAT_ASSISTANT'} label={t`ИИ-ассистент`} />
      <MenuItem
        to={Pages.MEDIA_MANAGER.INDEX}
        excludePaths={MEDIA_MANAGER_EXCLUDED_PATHS}
        icon={<Rss size={16} />}
        adminOnly
        feature={'MEDIA_MANAGER'}
        label={t`Медиа менеджер`}
      />
      <MenuItem
        to={Pages.MEDIA_MANAGER.QUEUE}
        icon={<ListTodo size={16} />}
        adminOnly
        feature={'MEDIA_MANAGER'}
        label={t`Очередь медиа`}
      />
      {/* Витрина кита. Гейт — `checkIsDev()`, тот же, что у роута: раздел есть и на TEST, где его смотрит дизайн. */}
      <MenuItem to={Pages.UI_KIT.INDEX} icon={<Puzzle size={16} />} label={'UI Kit'} adminOnly={true} hide={!checkIsDev()} />
    </div>
  );
});

export default UDMenuSystemNavigation;
